<template>
  <div
    class="border-b-1 border-solid border-black"
    :class="{ 'text-gray': disabled, 'is-active': open }"
  >
    <button
      class="flex items-center justify-between py-15 w-full"
      :class="[{ 'is-active': open }]"
      @click="open = !open"
    >
      <h5 class="is-5 uppercase">
        {{ label }} <span v-if="count">({{ count }})</span>
      </h5>
      <div class="">
        <ResponsiveSpriteSymbol
          :name="open ? 'chevron-up' : 'chevron-down'"
          class="w-[12px] h-20"
        />
      </div>
    </button>
    <div v-if="open" class="pb-10">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  disabled?: boolean
  count?: number
  label: string
}>()

const open = ref(false)
</script>
